import React from "react";
import "../GptSeoTracker.css";

const PROVIDER = { openai: "OpenAI", anthropic: "Anthropic", google: "Google", perplexity: "Perplexity" };
const usd = (n) => `$${(n || 0).toFixed(4)}`;

/**
 * Estimated cost of one report run: one row per model (tokens + web search
 * fee), a subtotal for the AI calls that run on every report but aren't
 * prompt responses (categorization judge + sentiment), and the total.
 * `cost` is the /gpt-seo/calculate-price payload.
 */
export default function CostBreakdown({ cost, loading, showMonthly = true }) {
  const b = cost?.breakdown;
  return (
    <div className="estimated-cost">
      {loading ? (
        <div className="cost-loading"><div className="loading-spinner" /></div>
      ) : (
        <>
          <div className="cost-amount">{usd(cost?.perRunCost)}<span className="cost-note" style={{ marginLeft: 6 }}>per run</span></div>
          {showMonthly && (
            <div className="cost-amount" style={{ fontSize: 16 }}>~${(cost?.perMonthCost || 0).toFixed(2)}<span className="cost-note" style={{ marginLeft: 6 }}>per month</span></div>
          )}
        </>
      )}
      {b && !loading && (
        <div className="cost-breakdown">
          {(b.models || []).map((m) => (
            <div key={m.id} className="cost-breakdown-row" title={`${m.calls} calls · tokens ${usd(m.tokens)} · web search ${usd(m.search)}`}>
              <span className="cost-breakdown-label">{m.name} <span className="cost-note">({PROVIDER[m.provider] || m.provider})</span></span>
              <span className="cost-breakdown-value">{usd(m.cost)}</span>
            </div>
          ))}
          <div className="cost-breakdown-row cost-breakdown-subtotal">
            <span className="cost-breakdown-label">Model responses</span>
            <span className="cost-breakdown-value">{usd(b.modelResponses)}</span>
          </div>
          <div className="cost-breakdown-row cost-breakdown-sub">
            <span className="cost-breakdown-label">Response analysis (gpt-5-nano)</span>
            <span className="cost-breakdown-value">{usd(b.categorization)}</span>
          </div>
          <div className="cost-breakdown-row cost-breakdown-sub">
            <span className="cost-breakdown-label">Sentiment (gpt-5-nano)</span>
            <span className="cost-breakdown-value">{usd(b.sentimentAnalysis)}</span>
          </div>
          <div className="cost-breakdown-row cost-breakdown-subtotal">
            <span className="cost-breakdown-label">Non-prompt AI calls</span>
            <span className="cost-breakdown-value">{usd(b.analysisSubtotal)}</span>
          </div>
          <div className="cost-breakdown-row cost-breakdown-total">
            <span className="cost-breakdown-label">Total per run</span>
            <span className="cost-breakdown-value">{usd(b.total)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
